<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vs-popup
      :active.sync="infoModal.active"
      title="รายละเอียด"
      class="custom-popup"
    >
      <div class="mb-5">
        <p v-html="infoModal.text"></p>
      </div>
    </vs-popup>

    <vx-card>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <vs-divider position="left" class="text-2xl">{{ $t('sections.prosecution.dataForm.title.prosecutionDetail') }}</vs-divider>
          <div class="vx-row flex">
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.lawyerAcceptedDate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.prosecution.dataForm.lawyerAcceptedDate')}}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.lawyerAcceptedDate" disabled="disabled"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.lawyerSendInquiryLetterDate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.prosecution.dataForm.lawyerSendInquiryLetterDate')}}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.lawyerSendInquiryLetterDate" disabled="disabled"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.dateOfFiling')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.prosecution.dataForm.dateOfFiling')}}* <a class="cursor-pointer" @click="onPressedActiveInfoModal('dateOfFiling')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <div class="flex items-center relative">
                  <flat-pickr
                    :config="configDatePicker"
                    class="w-full pr-10"
                    v-model="form.dateOfFiling"
                  />
                  <vs-button
                    v-if="form.dateOfFiling"
                    @click="form.dateOfFiling = null"
                    class="ml-2 bg-danger"
                  >
                    ✕
                  </vs-button>
                </div>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.principleFiling')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.principleFiling') }}</label>
                <vs-input type="number" v-model="form.principleFiling" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.interestFiling')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.interestFiling') }}</label>
                <vs-input type="number" v-model="form.interestFiling" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.penaltyFiling')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.penaltyFiling') }}</label>
                <vs-input type="number" v-model="form.penaltyFiling" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.feeFiling')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.feeFiling') }} <a class="cursor-pointer" @click="onPressedActiveInfoModal('fee')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <vs-input type="number" v-model="form.feeFiling" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.expenseDetailAmountFiling')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.expenseDetailAmountFiling') }} <a class="cursor-pointer" @click="onPressedActiveInfoModal('expenseDetailAmount')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <vs-input type="number" v-model="form.expenseDetailAmountFiling" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.collectionFeeFiling')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.collectionFeeFiling') }}</label>
                <vs-input type="number" v-model="form.collectionFeeFiling" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.lawyerFeeFiling')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.lawyerFeeFiling') }}</label>
                <vs-input type="number" v-model="form.lawyerFeeFiling" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.claimAmount')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.claimAmount') }}</label>
                <vs-input type="number" v-model="totalFiling" class="w-full" disabled="disabled"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <vs-divider position="left" class="text-2xl">{{ $t('sections.prosecution.dataForm.title.expense') }}</vs-divider>
          <div class="vx-row flex">
            <div class="vx-col w-1/3">
              <validation-provider :name="$t('sections.prosecution.dataForm.dateOfCourtFiling')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.dateOfCourtFiling") }}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.dateOfCourtFiling"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/3">
              <validation-provider :name="$t('sections.prosecution.dataForm.court')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.court") }}</label>
                <vs-input type="text" class="w-full" v-model="form.court" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.blackCaseNumber')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.blackCaseNumber") }}</label>
                <vs-input type="text" class="w-full" v-model="form.blackCaseNumber" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.courtFee')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.courtFee') }}</label>
                <vs-input type="number" v-model="form.courtFee" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.documentFee')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.documentFee') }}</label>
                <vs-input type="number" v-model="form.documentFee" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.sendOpponentFee')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.sendOpponentFee') }}</label>
                <vs-input type="number" v-model="form.sendOpponentFee" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.sendEnforcementFee')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.sendEnforcementFee') }}</label>
                <vs-input type="number" v-model="form.sendEnforcementFee" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <vs-divider position="left" class="text-2xl">{{ $t('sections.prosecution.dataForm.title.judgment') }}</vs-divider>
          <div class="vx-row flex ">
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.redCaseNumber')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.redCaseNumber") }} </label>
                <vs-input type="text" class="w-full" v-model="form.redCaseNumber" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.dateOfCourtJudgment')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.prosecution.dataForm.dateOfCourtJudgment')}}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.dateOfCourtJudgment"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.prosecutionResult')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.prosecutionResult") }}</label>
                <v-select v-model="form.prosecutionResult" :clearable="true" :options="prosecutionResultOptions" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex ">
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.prosecutionResultDescription')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.prosecution.dataForm.prosecutionResultDescription')}}</label>
                <vs-textarea v-model="form.prosecutionResultDescription" rows="3"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.prosecutionReasonDescription')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.prosecution.dataForm.prosecutionReasonDescription')}}</label>
                <vs-textarea v-model="form.prosecutionReasonDescription" rows="3"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.principle')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.principle') }}</label>
                <vs-input type="number" v-model="form.principleAfter" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.interest')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.interest') }}</label>
                <vs-input type="number" v-model="form.interestAfter" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.penalty')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.penalty') }}</label>
                <vs-input type="number" v-model="form.penaltyAfter" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.fee')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.fee') }} <a class="cursor-pointer" @click="onPressedActiveInfoModal('fee')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <vs-input type="number" v-model="form.feeAfter" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex ">
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.expenseDetailAmountAfter')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.expenseDetailAmountAfter') }} <a class="cursor-pointer" @click="onPressedActiveInfoModal('expenseDetailAmount')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <vs-input type="number" v-model="form.expenseDetailAmountAfter" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.collectionFee')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.collectionFee') }}</label>
                <vs-input type="number" v-model="form.collectionFeeAfter" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.lawyerFee')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.lawyerFee') }}</label>
                <vs-input type="number" v-model="form.lawyerFeeAfter" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.attorneyFeeByCourt')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.attorneyFeeByCourt') }}</label>
                <vs-input type="number" v-model="form.attorneyFeeByCourt" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>

          </div>
          <div class="vx-row flex ">
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.expenseAmountAfter')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.expenseAmountAfter') }} <a class="cursor-pointer" @click="onPressedActiveInfoModal('expenseAmountAfter')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <vs-input type="number" v-model="form.expenseAmountAfter" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.courtFeeReturn')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.courtFeeReturn') }} <a class="cursor-pointer" @click="onPressedActiveInfoModal('courtFeeReturn')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <vs-input type="number" v-model="form.courtFeeReturn" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="submit">{{ $t("sections.prosecution.dataForm.action.btnSave") }}</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">{{ $t("sections.prosecution.dataForm.action.btnReset") }}</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/themes/dark.css';
import {Thai} from "flatpickr/dist/l10n/th";

const { mapActions: mapProsecutionActions, mapState: mapProsecutionFields } = createNamespacedHelpers('Prosecution')

export default {
  components: {
    vSelect,
    ValidationProvider,
    flatPickr
  },
  data () {
    return {
      infoModal: {
        active: false,
        text: ""
      },
      form:{
        // รายละเอียดการดำเนินคดี ก่อนยื่นฟ้อง (เตรียมข้อมูลการยื่นฟ้อง และใช้ข้อมูลเพื่อยื่นฟ้อง)
        lawyerAcceptedDate: null, // วันที่ทนายรับเรื่อง
        lawyerSendInquiryLetterDate: null, // วันที่ทนายส่งหนังสือทวงถาม
        dateOfFiling: null,
        principleFiling: 0,
        interestFiling: 0,
        penaltyFiling: 0,
        feeFiling: 0,
        expenseDetailAmountFiling: 0,
        collectionFeeFiling: 0,
        lawyerFeeFiling: 0,
        claimAmountFiling: 0, // ทุนทรัพย์ฟ้อง
        // ค่าใช้จ่ายในการดำเนินคดี
        dateOfCourtFiling: null,
        court: null,
        blackCaseNumber: "",
        courtFee: 0,
        documentFee: 0,
        sendOpponentFee: 0,
        sendEnforcementFee: 0,
        totalExpenseAmount: 0,
        // คำพิพากษา
        redCaseNumber: "",
        dateOfCourtJudgment: "",
        prosecutionResult: null,
        prosecutionResultDescription: "",
        prosecutionReasonDescription: "",
        principleAfter: 0,
        interestAfter: 0,
        penaltyAfter: 0,
        feeAfter: 0,
        expenseDetailAmountAfter: 0,
        collectionFeeAfter: 0,
        lawyerFeeAfter: 0, // ค่าทนาย หรือค่าใช้จ่ายในการดำเนินคดี (ที่ระบุไว้ในสัญญา)
        attorneyFeeByCourt: 0, // ค่าทนายตามคำสั่งศาล
        expenseAmountAfter: 0, // ต่าฤชาธรรมเนียม
        courtFeeReturn: 0,
        totalAfter: 0,
      },
      configDatePicker: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y"
      },
    }
  },
  async created () {
    const vm = this
    vm.$vs.loading();
    await vm.initData();
    await vm.reset();
    setTimeout(() => {
      vm.created = true
      vm.$vs.loading.close();
    }, 100);
    // vm.pms ('ProsecutionTransaction', 'create', 'r')
  },
  computed: {
    ...mapProsecutionFields(['status', 'prosecution']),
    ...mapGetters({
      prosecutionResultOptions :'Prosecution/prosecutionResultOptions',
      caseStatusOptions :'Prosecution/caseStatusOptions',
    }),
    totalFiling: function () {
      return ['principleFiling', 'interestFiling', 'penaltyFiling', 'feeFiling', 'expenseDetailAmountFiling', 'collectionFeeFiling', 'lawyerFeeFiling']
        .map(key => parseFloat(this.form[key]) || 0)
        .reduce((sum, value) => sum + value, 0)
    },
  },
  methods: {
    ...mapProsecutionActions(['updateProsecutionLawyerJob', 'getProsecutionLawyerJob']),
    async onPressedActiveInfoModal(type) {
      if(type === 'caseNumber'){
        this.infoModal.text = '6701001 ปี ชุดที่ดำเนินคดี running'
      } else if(type === 'firstCollectionFeeLetterDate'){
        this.infoModal.text = 'วันที่ส่งหนังสือทวงถามครั้งแรก 30 วัน'
      } else if(type === 'sendCollectionFeeLetterCount'){
        this.infoModal.text = 'จำนวนครั้งที่โทรหรือไลน์ติดต่อลูกค้า'
      }else if(type === 'dateOfFiling'){
        this.infoModal.text = 'กำหนดให้ตรงกับวันฟ้อง'
      } else if(type === 'expenseDetailAmount'){
        this.infoModal.text = 'ค่าใช้จ่ายอื่นๆ เช่น ค่าธรรมเนียมการทำสัญญา ค่าอากรแสตมป์ ค่าดำเนินการ ค่าใช้จ่ายอื่นตามคำสั่งศาล เป็นต้น'
      } else if(type === 'fee'){
        this.infoModal.text = 'รวมค่าติดตามทวงถาม และหนังสือทวงถาม'
      }else if(type === 'expenseAmountAfter'){
        this.infoModal.text = 'ยอดรวมในหัวข้อ "ค่าใช้จ่ายในการดำเนินคดี (สำหรับฝ่ายกฎหมาย)" ที่ศาลอนุมัติให้เรียกเก็บจากลูกค้าได้ <br>'
        this.infoModal.text += `1. ${this.$t('sections.prosecution.dataForm.courtFee')} <br>`
        this.infoModal.text += `2. ${this.$t('sections.prosecution.dataForm.documentFee')} <br>`
        this.infoModal.text += `3. ${this.$t('sections.prosecution.dataForm.sendOpponentFee')} <br>`
        this.infoModal.text += `4. ${this.$t('sections.prosecution.dataForm.sendEnforcementFee')} <br>`
      } else if(type === 'courtFeeReturn'){
        this.infoModal.text = 'ค่าธรรมเนียมศาล กรณีศาลสั่งคืนให้กับบริษัทนำไปหักลบกับค่าธรรมเนียมศาล'
      }
      this.infoModal.active = true
    },
    initData: async function () {
      const vm = this
      const { getProsecutionLawyerJob } = vm
      await getProsecutionLawyerJob({form: {id: vm.$route.params.id}});
    },
    reset: async function () {
      const vm = this;
      vm.form = {
        // ProsecutionDetail รายละเอียดการดำเนินคดี
        lawyerAcceptedDate: vm.prosecution.lawyerAcceptedDate, // วันที่ทนายรับเรื่อง
        lawyerSendInquiryLetterDate: vm.prosecution.lawyerSendInquiryLetterDate, // วันที่ทนายส่งหนังสือทวงถาม
        dateOfFiling: vm.prosecution.dateOfFiling ? vm.$options.filters.convYYYYMMDDToDDMMYYYY(vm.prosecution.dateOfFiling) : null,
        principleFiling: vm.prosecution.principleFiling,
        interestFiling: vm.prosecution.interestFiling,
        penaltyFiling: vm.prosecution.penaltyFiling,
        feeFiling: vm.prosecution.feeFiling,
        expenseDetailAmountFiling: vm.prosecution.expenseDetailAmountFiling,
        collectionFeeFiling: vm.prosecution.collectionFeeFiling,
        lawyerFeeFiling: vm.prosecution.lawyerFeeFiling,
        // Expense ค่าใช้จ่ายในการดำเนินคดี
        dateOfCourtFiling: vm.prosecution.dateOfCourtFiling ? vm.$options.filters.convYYYYMMDDToDDMMYYYY(vm.prosecution.dateOfCourtFiling) : null,
        court: vm.prosecution.court,
        blackCaseNumber: vm.prosecution.blackCaseNumber,
        courtFee: vm.prosecution.courtFee,
        documentFee: vm.prosecution.documentFee,
        sendOpponentFee: vm.prosecution.sendOpponentFee,
        sendEnforcementFee: vm.prosecution.sendEnforcementFee,
        totalExpenseAmount: 0,
        // Judgment คำพิพากษา
        redCaseNumber: vm.prosecution.redCaseNumber,
        dateOfCourtJudgment: vm.prosecution.dateOfCourtJudgment ? vm.$options.filters.convYYYYMMDDToDDMMYYYY(vm.prosecution.dateOfCourtJudgment) : null,
        prosecutionResult: vm.prosecution.prosecutionResult,
        prosecutionResultDescription: vm.prosecution.prosecutionResultDescription,
        prosecutionReasonDescription: vm.prosecution.prosecutionReasonDescription,
        principleAfter: vm.prosecution.principleAfter,
        interestAfter: vm.prosecution.interestAfter,
        penaltyAfter: vm.prosecution.penaltyAfter,
        feeAfter: vm.prosecution.feeAfter,
        expenseDetailAmountAfter: vm.prosecution.expenseDetailAmountAfter,
        collectionFeeAfter: vm.prosecution.collectionFeeAfter,
        lawyerFeeAfter: vm.prosecution.lawyerFeeAfter, // ค่าทนาย หรือค่าใช้จ่ายในการดำเนินคดี (ที่ระบุไว้ในสัญญา)
        attorneyFeeByCourt: vm.prosecution.attorneyFeeByCourt, // ค่าทนายตามคำสั่งศาล
        expenseAmountAfter: vm.prosecution.expenseAmountAfter, // ต่าฤชาธรรมเนียม
        courtFeeReturn: vm.prosecution.courtFeeReturn,
        totalAfter: 0,
      }
    },
    submit: async function () {
      const vm = this
      const { updateProsecutionLawyerJob } = vm
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }
        updateProsecutionLawyerJob({
          id: vm.$route.params.id,
          form: {
            // ProsecutionDetail รายละเอียดการดำเนินคดี
            // lawyerAcceptedDate: vm.form.lawyerAcceptedDate ? vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.lawyerAcceptedDate) : null, // วันที่ทนายรับเรื่อง
            // lawyerSendInquiryLetterDate: vm.form.lawyerSendInquiryLetterDate ? vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.lawyerSendInquiryLetterDate) : null, // วันที่ทนายส่งหนังสือทวงถาม
            dateOfFiling: vm.form.dateOfFiling ? vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.dateOfFiling) : null,
            principleFiling: parseFloat(vm.form.principleFiling),
            interestFiling: parseFloat(vm.form.interestFiling),
            penaltyFiling: parseFloat(vm.form.penaltyFiling),
            feeFiling: parseFloat(vm.form.feeFiling),
            expenseDetailAmountFiling: parseFloat(vm.form.expenseDetailAmountFiling),
            collectionFeeFiling: parseFloat(vm.form.collectionFeeFiling),
            lawyerFeeFiling: parseFloat(vm.form.lawyerFeeFiling),
            claimAmount: parseFloat(vm.form.claimAmount),
            // Expense ค่าใช้จ่ายในการดำเนินคดี
            dateOfCourtFiling: vm.form.dateOfCourtFiling ? vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.dateOfCourtFiling) : null,
            court: vm.form.court,
            blackCaseNumber: vm.form.blackCaseNumber,
            courtFee: parseFloat(vm.form.courtFee),
            documentFee: parseFloat(vm.form.documentFee),
            sendOpponentFee: parseFloat(vm.form.sendOpponentFee),
            sendEnforcementFee:  parseFloat(vm.form.sendEnforcementFee),
            totalExpenseAmount: 0,
            // Judgment คำพิพากษา
            redCaseNumber: vm.form.redCaseNumber,
            dateOfCourtJudgment: vm.form.dateOfCourtJudgment ? vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.dateOfCourtJudgment) : null,
            prosecutionResult: vm.form.prosecutionResult,
            prosecutionResultDescription: vm.form.prosecutionResultDescription,
            prosecutionReasonDescription: vm.form.prosecutionReasonDescription,
            principleAfter: parseFloat(vm.form.principleAfter),
            interestAfter: parseFloat(vm.form.interestAfter),
            penaltyAfter: parseFloat(vm.form.penaltyAfter),
            feeAfter: parseFloat(vm.form.feeAfter),
            expenseDetailAmountAfter: parseFloat(vm.form.expenseDetailAmountAfter),
            collectionFeeAfter: parseFloat(vm.form.collectionFeeAfter),
            lawyerFeeAfter: parseFloat(vm.form.lawyerFeeAfter),
            attorneyFeeByCourt: parseFloat(vm.form.attorneyFeeByCourt),
            expenseAmountAfter: parseFloat(vm.form.expenseAmountAfter), // ต่าฤชาธรรมเนียม
            courtFeeReturn: parseFloat(vm.form.courtFeeReturn),
            totalAfter: 0,
          },
          vm,
          redirect: "/prosecution/lawyerJob"
        })
      })
    },
  },
  watch: {
    status: {
      handler(res){
        if(res.processing !== null){
          if(res.processing){
            this.$vs.loading();
          }else{
            this.$vs.loading.close();
          }
        }
        if(res.success !== null){
          this.$vs.notify({...res.success})
        }else if(res.error !== null){
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.vx-col {
  margin-bottom: 1rem; /* This is the equivalent of Bootstrap's mt-5 */
}
</style>
